export default "__VITE_ASSET__DvfXm5DK__"